export const userKeys = {
  all: ["user"] as const,
  planExpiry: () => [...userKeys.all, "planExpiry"] as const,
userPlan: () => [...userKeys.all, "userPlan"] as const,
};